import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PasswordErrorMessage, ResetPasswordModel } from '@core/services/user/user.model';
import { UserService } from '@core/services/user/user.service';
import { mustMatchValidator } from '@shared/directives/must-match.directive';
import { ToastrService } from 'ngx-toastr';
import { CustomizeErrorStateMatcher } from '../customize-error-state-matcher';

@Component({
  selector: 'Teranet-ResetPassword',
  templateUrl: './reset-password.component.html'
})
export class ResetPasswordComponent implements OnInit {
  matcher = new CustomizeErrorStateMatcher();
  passwordErrorMessage = PasswordErrorMessage;
  resetPasswordForm: FormGroup;
  resetResult: boolean = false;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ResetPasswordComponent>,
    private userService: UserService,
    private toastrService: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.resetPasswordForm = this.fb.group(
      {
        id: new FormControl(this.data.id),
        newPassword: new FormControl('', [
          Validators.required,
          Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@%+!$&?()[\\]/\\\\]).{10,}'),
        ]),
        confirmNewPassword: new FormControl('', [
          Validators.required,
          Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@%+!$&?()[\\]/\\\\]).{10,}'),
        ]),
      },
      {
        validator: mustMatchValidator('newPassword', 'confirmNewPassword')
      });
  }

  ngOnInit(): void { }

  onClose(): void {
    this.dialogRef.close(this.resetResult);
  }

  resetPassword(form: NgForm): void {
    if (
      this.resetPasswordForm.valid &&
      this.data.id != null &&
      typeof this.data.id === 'number' &&
      this.data.id > 0
    ) {
      const resetPassword: ResetPasswordModel = {
        id: this.data.id,
        newPassword: this.resetPasswordForm.get('newPassword').value,
      };
      this.userService.resetPassword(resetPassword).subscribe(data => {
        if (data != null && typeof data === 'boolean' && data == true) {
          this.resetResult = true;
          this.dialogRef.close(this.resetResult);
        }
      });
      form.resetForm();
    } else {
      this.toastrService.error('Something went wrong, please verify the user.', 'Reset Password');
      this.dialogRef.close(this.resetResult);
    }
  }
}
